import { c as _c } from "react/compiler-runtime";
import { Classic } from "loading-dev";
import { AnimatePresence, m } from "motion/react";
import { Button } from "@/components/ui/button";
import { slideVariants, springTransitions } from "@/lib/animation-presets";
const swap = slideVariants(16);
interface AnimatedSubmitButtonProps {
  disabled?: boolean;
  isLoading: boolean;
  label: string;
  size?: "md" | "lg";
}
export function AnimatedSubmitButton(t0) {
  const $ = _c(9);
  const {
    label,
    isLoading,
    disabled,
    size: t1
  } = t0;
  const size = t1 === undefined ? "lg" : t1;
  const t2 = disabled ?? isLoading;
  let t3;
  if ($[0] !== isLoading || $[1] !== label) {
    t3 = <AnimatePresence initial={false} mode="popLayout">{isLoading ? <m.div key="spinner" transition={springTransitions.normal} {...swap}><Classic aria-hidden="true" size={16} /></m.div> : <m.span key="text" transition={springTransitions.normal} {...swap}>{label}</m.span>}</AnimatePresence>;
    $[0] = isLoading;
    $[1] = label;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isLoading || $[4] !== label || $[5] !== size || $[6] !== t2 || $[7] !== t3) {
    t4 = <Button aria-busy={isLoading} aria-label={label} className="relative w-full overflow-hidden" disabled={t2} size={size} type="submit">{t3}</Button>;
    $[3] = isLoading;
    $[4] = label;
    $[5] = size;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}